import { SpoolDto } from '../../../../../types/spool-local';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../../../components/Loading';
import {
    EmptyDataRow,
    Pagination,
    Table,
    TableRowContainer,
} from '../../../../components/Table';
import spoolsContext from '../../../../context/spools/spoolsContext';
import useSpoolsCreatedByUser from '../../../../hooks/web3/app/useSpoolsCreatedByUser';
import SpoolCreatorFeesAccordion from './SpoolCreatorFeesAccordion';
import SpoolCreatorFeesHeader from './SpoolCreatorFeesHeader';

type CreatorFeesParam = {
    spoolAddress: string | undefined;
};

const SpoolCreatorFees = () => {
    const { activeSort, searchTerm, activeFilter, filterData, sort, setSearchTerm } =
        useContext(spoolsContext);

    const { spoolsCreatedByUser, isLoading } = useSpoolsCreatedByUser();

    const [selectedAccordion, setSelectedAccordion] = useState<string | null>(null);
    const [filteredData, setFilteredData] = useState<SpoolDto[]>([]);

    const { spoolAddress } = useParams<CreatorFeesParam>();

    const toggle = (spoolAddress: string) => {
        setSelectedAccordion((prev) => (prev === spoolAddress ? null : spoolAddress));
    };

    useEffect(() => {
        if (!spoolsCreatedByUser) return;

        const filtered = spoolsCreatedByUser.filter((data) =>
            filterData(data, activeFilter, searchTerm)
        );

        setFilteredData(filtered);
    }, [spoolsCreatedByUser, activeFilter, searchTerm, filterData]);

    useEffect(() => {
        if (spoolAddress) {
            setSearchTerm(spoolAddress);
        }
    }, [spoolAddress, setSearchTerm]);

    return (
        <Table
            headers={
                <SpoolCreatorFeesHeader hasFilteredResults={!!filteredData.length} />
            }
            numOfColumns={5}
            dataLength={spoolsCreatedByUser?.length || 0}
            className='spool-creator-fees-table'
        >
            <Loading isLoading={isLoading} text='Loading your Created Spools...'>
                <TableRowContainer>
                    {spoolsCreatedByUser ? (
                        filteredData.length ? (
                            filteredData
                                .sort((a, b) => sort(a, b, activeSort))
                                .map((spoolDetails, index) => (
                                    <SpoolCreatorFeesAccordion
                                        key={index}
                                        spoolDetails={spoolDetails}
                                        collapsed={
                                            selectedAccordion === spoolDetails.address
                                        }
                                        toggle={() => toggle(spoolDetails.address)}
                                    />
                                ))
                        ) : (
                            <EmptyDataRow text='No Spools or Risk Models match your search criteria, please try again.' />
                        )
                    ) : (
                        <EmptyDataRow text='An unexpected error occurred while loading your Created Spools.' />
                    )}
                </TableRowContainer>
            </Loading>
            <Pagination rowPerPage={6} />
        </Table>
    );
};

export default SpoolCreatorFees;
